export enum MessageType { SUCCESS, INFO, ERROR }

export interface Message {
  type: MessageType;
  message: string;
  description?: string;
}
